import * as React from 'react';
import * as styles from './like-dislike-group.styles';
import { LikeDislikeButton } from './like-dislike-button';

export type LikeDislikeGroupProps = {
  likes: number;
  dislikes: number;
  opinion: 'LIKE' | 'DISLIKE' | null;
  onLike?: () => void;
  onDislike?: () => void;
} & React.HTMLAttributes<HTMLElement>;

namespace validation {
  export const isValueValid = (value: number) => {
    return value >= 0;
  };
}

export const LikeDislikeGroup: React.FC<LikeDislikeGroupProps> = ({
  likes,
  dislikes,
  opinion,
  onLike = () => {},
  onDislike = () => {},
  ...htmlProps
}) => {
  return (
    <div className={styles.likeDislikeGroupWrapper} {...htmlProps}>
      <LikeDislikeButton
        type="LIKE"
        selected={opinion === 'LIKE'}
        value={getValue(likes)}
        onClick={onLike}
      />
      <LikeDislikeButton
        type="DISLIKE"
        selected={opinion === 'DISLIKE'}
        value={getValue(dislikes)}
        onClick={onDislike}
      />
    </div>
  );
};

function getValue(input: number) {
  return validation.isValueValid(input) ? input : 0;
}
